import { Drawer as AntdDrawer } from "antd";

export default function Drawer(props) {
  const closeIcon = <div className="actionIconsSprite drawer-close-icon" />;
  return (
    <AntdDrawer destroyOnClose={props?.destroyOnClose || true} {...props} closeIcon={closeIcon} className={`hs-drawer ${props.className}`} />
  );
}
